import { mdiAlert, mdiAlertCircle, mdiCheckUnderline } from "@mdi/js";
import Icon from "@mdi/react";
import { Loading } from "notiflix";
import React from "react";

export const loadingSc = (visible) => {
  if (visible) {
    Loading.hourglass({
      clickToClose: false,
      backgroundColor: "rgba(0,0,0,0.35)",
      svgColor: "#344e75",
    });
  } else {
    Loading.remove();
  }
};

export function DangerAlert({ head, content }) {
  return (
    <div className="alert alert-danger" role="alert" style={{ textAlign: "left", fontSize: "12px" }}>
      <div className="row">
        <div className="col-sm-1" style={{ paddingRight: "0px", marginRight: "0px" }}>
          <Icon path={mdiAlertCircle} size={1.5} style={{ color: "#b62f2f" }} />
        </div>
        <div className="col-sm-10" style={{ paddingLeft: "0px", marginLeft: "0px" }}>
          <b>{head}</b>
          <br />
          {content}
        </div>
      </div>
    </div>
  );
}

export function SuccessAlert({ head, content }) {
  return (
    <div className="alert alert-success" role="alert" style={{ textAlign: "left", fontSize: "12px" }}>
      <div className="row">
        <div className="col-sm-1" style={{ paddingRight: "0px", marginRight: "0px" }}>
          <Icon path={mdiCheckUnderline} size={1.5} style={{ color: "#49a128" }} />
        </div>
        <div className="col-sm-10" style={{ paddingLeft: "0px", marginLeft: "0px" }}>
          <b>{head}</b>
          <br />
          {content}
        </div>
      </div>
    </div>
  );
}

export function WarningAlert({ head, content }) {
  return (
    <div className="alert alert-warning" role="alert" style={{ textAlign: "left", fontSize: "12px" }}>
      <div className="row">
        <div className="col-sm-1" style={{ paddingRight: "0px", marginRight: "0px" }}>
          <Icon path={mdiAlert} size={1.5} style={{ color: "#ff985f" }} />
        </div>
        <div className="col-sm-10" style={{ paddingLeft: "0px", marginLeft: "0px" }}>
          <b>{head}</b>
          <br />
          {content}
        </div>
      </div>
    </div>
  );
}
